<template>
  <div class="col-auto bg-white attendance-header tw-px-4 tw-py-2 tw-border-0 tw-border-b tw-border-solid tw-border-bluegrey-10/10 tw-shadow-sm tw-font-inter">
    <div class="row items-center no-wrap full-width tw-gap-1">
      <div class="col tw-min-w-0">
        <div class="row items-center no-wrap tw-min-w-0">
          <div
            v-if="showAvatar"
            class="col-auto avatar-initial tw-mr-2.5 tw-flex tw-h-9 tw-w-9 tw-select-none tw-items-center tw-justify-center tw-rounded-full tw-bg-primary/10 tw-text-sm tw-font-semibold tw-text-primary"
          >
            {{ (contact || displayPhone || '?').charAt(0).toUpperCase() }}
          </div>

          <div class="column tw-min-w-0">
            <div class="col-auto row items-center no-wrap full-width">
              <ArrowIn
                v-if="direction === 'IN'"
                class="col-auto"
              />

              <ArrowOut
                v-if="direction === 'OUT'"
                class="col-auto"
              />

              <ArrowInOut
                v-if="direction === 'AUTO' || (!direction && !showButtonFinishChat)"
                class="col-auto"
              />

              <div class="col-auto contact-name q-pl-xs ellipsis">
                <span
                  class="tw-text-[13px] tw-font-semibold tw-leading-4 tw-text-bluegrey-10"
                  :class="{ 'no-select': isShowingAnonymizedPhone }"
                >
                  {{ contact || displayPhone }}
                </span>

                <q-tooltip v-if="isShowingAnonymizedPhone">
                  Número anonimizado por política de segurança
                </q-tooltip>

                <q-tooltip v-if="showContactTooltip">
                  {{ contactTooltip }}
                </q-tooltip>
              </div>

              <EditName
                v-if="isText"
                :attendance="attendance"
                :contact="contact"
                :channel="channel"
              />
            </div>

            <div class="col-auto row items-center header-meta tw-mt-1 tw-gap-1 tw-overflow-hidden">
              <div class="row items-center no-wrap header-timer tw-rounded-full tw-bg-greyc-4 tw-px-2 tw-py-[3px]">
                <WatchLogo class="col-auto watch-icon" />

                <TimerWrapper
                  class="col-auto tw-text-xs tw-leading-[13px] tw-font-normal tw-text-bluegrey-10 q-pl-xs q-pr-sm"
                  :created-at="createdAt"
                  :finished-at="finishedAt"
                />

                <span
                  v-if="contact && contact !== id"
                  class="col tw-min-w-0 tw-truncate tw-text-[13px] tw-leading-[13px] tw-font-bold tw-text-gray-500 q-pr-xs"
                  :class="{ 'no-select': isAnonymizationEnabled }"
                >
                  {{ formatName(id) }}
                  <q-tooltip>
                    {{ formatName(id) }}
                    <template v-if="isAnonymizationEnabled">
                      (anonimizado por política de segurança)
                    </template>
                  </q-tooltip>
                </span>
              </div>

              <span
                v-if="queueName"
                class="col-auto row no-wrap tw-overflow-hidden tw-rounded-full tw-shadow-sm"
              >
                <span class="queue-badge__label tw-flex tw-items-center tw-bg-primary-hover tw-px-2 tw-py-[3px] tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-leading-[14px] tw-text-white">Fila</span>
                <span class="queue-badge__value tw-truncate tw-bg-primary tw-px-2.5 tw-py-[3px] tw-text-xs tw-font-semibold tw-leading-[14px] tw-text-white">{{ queueName }}</span>
                <q-tooltip>Fila: {{ queueName }}</q-tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>

      <ListBrokers
        size="13px"
        v-if="isVoice"
        class-name="col-auto q-pr-sm"
        @on-template-select="handleStartChat"
      />
      <q-icon
        color="primary"
        name="mdi-calendar"
        class="cursor-pointer tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-transition hover:tw-bg-greyc-4"
        data-testid="atendimento-agendar"
        @click="openCalendar"
      />
      <q-btn
        dense
        no-caps
        unelevated
        padding="0"
        icon="mdi-phone-return"
        size="12px"
        class="col-auto text-green-8 tw-h-7 tw-w-7 tw-rounded-full tw-transition hover:tw-bg-greyc-4"
        v-if="isText && !isPreview"
        :disable="disableWhenPause"
        data-testid="atendimento-discar"
        @click="handleStarDial"
      >
        <q-tooltip content-class="bg-green-8 text-bold">
          Discar para esse número
        </q-tooltip>
      </q-btn>

      <q-btn
        dense
        no-caps
        unelevated
        padding="0"
        icon="mdi-phone-return"
        size="12px"
        class="col-auto text-orange-8 tw-h-7 tw-w-7 tw-rounded-full tw-transition hover:tw-bg-greyc-4"
        data-testid="atendimento-rediscar"
        @click="handleRedial"
        v-if="!showButtonFinishChat && finishedAt && isVoice && !isPreview"
      >
        <q-tooltip content-class="bg-orange-8 text-bold">
          Rediscar para o número
        </q-tooltip>
      </q-btn>

      <q-btn
        data-testid="atendimento-transferir"
        dense
        :disable="disableTransfer"
        flat
        padding="0"
        class="col-auto tw-text-[13px] tw-font-normal tw-h-7 tw-w-7 tw-rounded-full tw-transition hover:tw-bg-greyc-4"
        color="orange-8"
        icon="mdi-swap-horizontal"
        v-if="!isAdmin && (showButtonFinishChat || isText) && !finishedAt"
      >
        <q-menu
          class="border-menu"
          ref="menu"
          @hide="() => $emit('change-destination', null)"
        >
          <AttendanceChatTransfer
            :chat-id="attendance.id"
            :agent-id="attendance.agentId"
            :queue-id="attendance.queueId"
            :direction="attendance.direction"
            :destination="destination"
            @hide-menu="() => $refs.menu.hide()"
          />
        </q-menu>
        <q-tooltip content-class="bg-orange-8">
          <span>
            Transferir atendimento
          </span>
        </q-tooltip>
      </q-btn>

      <span
        v-if="!isAdmin && (showButtonFinishChat || isVoice) && !finishedAt"
        class="col-auto"
      >
        <q-btn
          dense
          :disable="disableWhenPause || disableFinish"
          flat
          padding="0"
          class="tw-text-[13px] tw-font-normal tw-h-7 tw-w-7 tw-rounded-full tw-transition hover:tw-bg-greyc-4"
          color="red-8"
          data-testid="atendimento-finalizar"
          @click="handleFinish"
          :loading="isFinishing"
          :icon="attendanceIcon"
        />
        <q-tooltip content-class="bg-red-8">
          <span>
            {{ disableFinish ? 'Aguardando resposta do contato' : 'Finalizar atendimento' }}
          </span>
        </q-tooltip>
      </span>

      <AttendanceHeaderTabs
        v-if="!isPreview"
        @change-view="$emit('change-view', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TimerWrapper from '@/components/TimerWrapper'
import WatchLogo from '@/assets/icons/watch.svg'
import ArrowIn from '@/assets/icons/arrowIn.svg'
import ArrowOut from '@/assets/icons/arrowOut.svg'
import ArrowInOut from '@/assets/icons/arrowInOut.svg'
import ListBrokers from '@/components/ListBrokers'
import AttendanceHeaderTabs from './AttendanceHeaderTabs.vue'
import AttendanceChatTransfer from './AttendanceChatTransfer.vue'
import { retryStartCall, startChat } from '@/libs/startAttendance'
import { getContactNumber } from '@/libs/helpers'
import EditName from './EditName'
import { anonymizePhone } from '@/components/utils/phones'
import { contactInfoTooltip } from '@/libs/contactInfo'

export default {
  components: {
    ArrowIn,
    EditName,
    ArrowOut,
    WatchLogo,
    ArrowInOut,
    ListBrokers,
    TimerWrapper,
    AttendanceHeaderTabs,
    AttendanceChatTransfer
  },

  props: {
    contact: {
      type: String,
      require: true
    },

    id: {
      type: String,
      require: false
    },

    createdAt: {
      type: Number,
      require: true
    },

    finishedAt: {
      type: Number,
      require: false
    },

    channel: {
      type: String
    },

    queueName: {
      type: [String, Number],
      default: null
    },

    direction: {
      type: String
    },

    showButtonFinishChat: {
      type: Boolean,
      default: false
    },

    attendance: {},

    disableWhenPause: {
      type: Boolean,
      default: false
    },

    isPreview: {
      type: Boolean,
      default: false
    },

    destination: {
      type: Number,
      default: null
    },

    disableTransfer: {
      type: Boolean,
      default: false
    },

    disableFinish: {
      type: Boolean,
      default: false
    }
  },

  emits: ['on-finish'],

  methods: {
    handleStarDial () {
      const vm = this
      if (!vm.attendance) return
      const attendance = { ...vm.attendance }
      attendance.contact = getContactNumber(attendance)
      attendance.direction = ''

      retryStartCall(vm, attendance)
    },

    handleStartChat (template) {
      const vm = this
      const templateId = template.id
      const destination = vm.attendance.contact
      startChat(vm, destination, templateId, template)
    },

    handleFinish () {
      if (this.isFinishing) return
      this.$emit('on-finish')
    },

    formatName (contactId) {
      if (!contactId) return ''
      const isListenExtension = contactId.includes('*99*')
      if (!isListenExtension) return this.displayPhone
      const extension = contactId.split('*99*').pop().split('@').shift()
      return `Ouvir Ramal ${extension}`
    },

    handleRedial () {
      const vm = this
      retryStartCall(vm, vm.attendance)
    },

    openCalendar () {
      this.$router.push({
        name: 'ROUTE_CALENDAR',
        query: { attendance: JSON.stringify(this.attendance), onlyCreate: true }
      })
    }
  },

  computed: {
    ...mapGetters({
      isAdmin: 'settingsModule/isAdmin',
      queueProperties: 'agentModule/queueProperties',
      isFinishing: 'attendanceModule/isLoading'
    }),

    queueId () {
      if (!this.attendance || typeof this.attendance !== 'object') return null
      return this.attendance.queueId ?? this.attendance.queue
    },

    isAnonymizationEnabled () {
      const noQueue = !this.queueId || this.queueId === ''
      if (noQueue && this.attendance?.shouldAnonymize) return true

      const queueProps = this.queueProperties(this.queueId)
      if (!Object.keys(queueProps).length === 0) return true
      return queueProps?.anonymizePhone === 'yes'
    },

    isAnonymizedContact () {
      return Boolean(this.isAnonymizationEnabled && this.id)
    },

    isShowingAnonymizedPhone () {
      return this.isAnonymizedContact && (this.isVoice || !this.contact)
    },

    displayPhone () {
      const phone = this.id
      if (!phone) return phone
      if (this.isAnonymizationEnabled) return anonymizePhone(phone)
      return phone
    },

    showContactTooltip () {
      return this.isText && Boolean(this.contact)
    },

    contactTooltip () {
      return contactInfoTooltip(this.attendance?.info)
    },

    isVoice () {
      return this.channel === 'VOICE'
    },

    showAvatar () {
      if (!this.isVoice) return true
      return Boolean(String(this.contact ?? '').trim())
    },

    isText () {
      return this.channel === 'TEXT'
    },

    attendanceIcon () {
      return this.isVoice ? 'mdi-phone-classic' : 'mdi-chat-remove-outline'
    }
  },

  watch: {
    deep: true,
    destination (value) {
      if (value) this.$refs.menu.show()
    }
  }
}

</script>

<style lang="sass" scoped>
.watch-icon
  height: 14px
  width: 14px

.watch-icon > path
  fill: #01253C

.contact-name
  max-width: 120px

.queue-badge__value
  max-width: 150px

.header-timer
  min-width: max-content

@media (max-width: 1000px)
  .avatar-initial
    display: none !important

  .queue-badge__label
    display: none !important

  .queue-badge__value
    max-width: 110px

  .contact-name
    max-width: 100px

@media (max-width: 760px)
  .attendance-header
    padding-left: 8px !important
    padding-right: 8px !important

.no-select
  user-select: none
  -webkit-user-select: none
  -moz-user-select: none
  -ms-user-select: none
</style>
